import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import { AutoComplete, TextInput } from '../../../../../components'
import { STATUS } from '../../../../../utils'
import { capitalize } from 'lodash'

/**
 * Record Detail
 */
class RecordDetail extends PureComponent {
  /**
   * Render
   * @return {XML}
   */
  render () {
    const { values, setFieldValue } = this.props

    return (
      <Grid item xs={9} container spacing={3}>
        <Grid item xs={12}>
          <div className='section_title section_title--first'>Record ID Detail</div>
        </Grid>

        <Grid item xs={12} container spacing={3}>
          <Grid item xs>
            <div className='field field--text'>
              <label className='field_label'>Record ID</label>
              <TextInput
                id='id'
                disabled
                value={values.id} />
            </div>
          </Grid>
          <Grid item xs>
            <div className='field field--text'>
              <label className='field_label'>Record Source</label>
              <TextInput
                id='source'
                disabled
                value={capitalize(values.source)} />
            </div>
          </Grid>
          <Grid item xs>
            <div className='field'>
              <label className='field_label'>Status</label>
              <AutoComplete
                name='status'
                placeholder='Select'
                value={STATUS.find((option) => option.value === values.status)}
                options={STATUS}
                onChange={(option) => setFieldValue('status', option.value)}
                searchable={false}
                clearable={false} />
            </div>
          </Grid>
        </Grid>
      </Grid>
    )
  }
}

RecordDetail.propTypes = {
  values: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired
}

export default RecordDetail
